export const getCurrentUser = (state) => state.user;
export const getCurrentUserCommunities = (s) => s.user && s.user.myCommunities;
export const getUserCommunitiesRequest = (state) =>
  state.user.requests.communities;

export default {
  getCurrentUser,
  getCurrentUserCommunities,
  getUserCommunitiesRequest
};
